import type { IPolicy } from '@adornis/abac/core/types.js';
import { isNullish } from '@adornis/assert/isNullish.js';
import {
  ensureLoggedInPayload,
  type LoggedInEvaluationFunction,
} from '../permissions/abac-payloads/checkLoggedInPayload.js';
import { MARTINUS_ABAC_PAYLOAD, type MartinusAbacPayload } from '../permissions/abac-payloads/MartinusAbacPayload.js';

export enum AdminDashboardActions {
  VIEW_ADMIN_DASHBOARD = 'VIEW_ADMIN_DASHBOARD',
}

const AdminDashboardPolicyFunctions: Record<AdminDashboardActions, LoggedInEvaluationFunction<MartinusAbacPayload>> = {
  /**
   * Noone can see the admin dashboard. Admins can see it trough the AdminPolicy
   */
  [AdminDashboardActions.VIEW_ADMIN_DASHBOARD]: async () => {
    return { allowed: false, reason: 'Noone can see the admin dashboard' };
  },
};

export const AdminDashboardPolicy: IPolicy<MartinusAbacPayload> = {
  name: 'AdminDashboardPolicy',
  acceptingPayloadTypes: [MARTINUS_ABAC_PAYLOAD],
  async evaluate(request) {
    /**
     * Check logged in user
     */
    request.payload = ensureLoggedInPayload(request.payload);

    /**
     * Execute the correct function for the action
     */
    const result = await AdminDashboardPolicyFunctions[request.payload.action]?.(request);

    if (isNullish(result)) return false;
    return result;
  },
};
